import axios from 'axios'

const billing = {
  state: () => ({
    loading: false,
    billingPlans: [],
    billingAccount: null,
    billingUsage: {},
    error: null,
  }),

  getters: {
    getBillingPlan: (state) => (billingPlanId) => {
      if (state.billingPlans.length > 0) {
        const found = state.billingPlans.find(billingPlan => {
          if (billingPlan.id == billingPlanId) {
            return billingPlan
          }
        })
        if (found) {
          return found
        }
        return {
          name: 'Unknown',
        }
      }
      return {
        name: 'Unknown',
      }
    }
  },

  mutations: {
    SET_BILLING_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_BILLING_ERROR: (state, error) => {
      state.error = error
    },
    SET_BILLING_PLANS: (state, billingPlans) => {
      state.billingPlans = billingPlans
    },
    SET_BILLING_ACCOUNT: (state, billingAccount) => {
      state.billingAccount = billingAccount
    },    
    SET_BILLING_ACCOUNT_USAGE: (state, billingUsage) => {
      state.billingUsage = billingUsage
    },
  },
  actions: {
    GetBillingAccount (context, query) {
      context.commit('SET_BILLING_LOADING', true)
      context.commit('SET_BILLING_ERROR', null)
      let url = `/billing/account`
      if (query.projectId) {
        url += `?projectId=${query.projectId}`        
      }
      return axios.get(url)
        .then((response) => {
          context.commit('SET_BILLING_LOADING', false)
          context.commit('SET_BILLING_ACCOUNT', response.data)
        })
        .catch((error) => {
          context.commit('SET_BILLING_LOADING', false)
          context.commit('SET_BILLING_ERROR', error.response.data.error.message)
        })
    },
    GetBillingUsage (context, query) {
      context.commit('SET_BILLING_LOADING', true)
      context.commit('SET_BILLING_ERROR', null)
      return axios.get(`/billing/usage?projectId=${query.projectId}`)
        .then((response) => {
          context.commit('SET_BILLING_LOADING', false)
          context.commit('SET_BILLING_ACCOUNT_USAGE', response.data)
        })
        .catch((error) => {
          context.commit('SET_BILLING_LOADING', false)
          context.commit('SET_BILLING_ERROR', error.response.data.error.message)
        })
    },
    SetupCheckoutSession(context, query) {
      context.commit('SET_BILLING_ERROR', null)
      return axios.post(`billing/accounts/${query.id}/setup-checkout?projectId=${query.projectId}`)
        .then((response) => {
          window.location.replace(response.data.redirectUrl);
        })
        .catch((error) => context.commit('SET_BILLING_ERROR', error.response.data.error.message))
    },
    SubscribeToPlan(context, query) {
      context.commit('SET_BILLING_LOADING', true)
      context.commit('SET_BILLING_ERROR', null)
      return axios.post(`billing/checkout`, {
        planId: query.planId,
      })
        .then((response) => {
          context.commit('SET_BILLING_LOADING', false)
          if (response.data.redirectRequired) {
            window.location.replace(response.data.redirectUrl);
            return
          }
          // All good
        })
        .catch((error) => {
          context.commit('SET_BILLING_ERROR', error.response.data.error.message)
          context.commit('SET_BILLING_LOADING', false)
        })
    },
    RemovePaymentMethod(context, query) {
      context.commit('SET_BILLING_ERROR', null)
      return axios.delete(`billing/accounts/${query.id}/payment-method`)
        .then((response) => {
          context.commit('SET_BILLING_ACCOUNT', response.data)
        })
        .catch((error) => context.commit('SET_BILLING_ERROR', error.response.data.error.message))
    },
    // ListBillingPlans are the plans that are available to the user to subscribe.
    ListBillingPlans (context) {
      context.commit('SET_BILLING_LOADING', true)
      return axios.get(`/billing/plans`)
        .then((response) => {
          context.commit('SET_BILLING_PLANS', response.data)
          context.commit('SET_BILLING_LOADING', false)
        })
        .catch((error) => {
          context.commit('SET_BILLING_ERROR', error.response.data.error.message)
          context.commit('SET_BILLING_LOADING', false)
        })
    },
    UnlinkProjectFromBillingAccount(context, query) {
      context.commit('SET_BILLING_ERROR', null)
      return axios.delete(`billing/accounts/${query.id}/projects/${query.projectId}`)
        .then(() => {
          context.commit('SET_BILLING_ERROR', null)
        })
        .catch((error) => context.commit('SET_BILLING_ERROR', error.response.data.error.message))
    },
  }
}

export default billing
